/* eslint-disable import/order */

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app';

export const updatePrevPath = createAsyncThunk(
  'app/updatePrevPath',
  async (body: string, { rejectWithValue }) => {
    try {
      return body;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface AppState {
  store: any;
  system: any;
  domains: any;
  isHasData: boolean;
  isLoading: boolean;
  isLoadingCategory: boolean;
  isHasDataCategory: boolean;
  categories: any[];
  prevPath: string;
}

const initialState: AppState = {
  store: {},
  system: {},
  domains: {},
  categories: [],
  isHasData: false,
  isLoading: true,
  isLoadingCategory: true,
  isHasDataCategory: false,
  prevPath: '/',
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    initialAppState(state, { payload }) {
      if (state.isLoading) {
        state.system = payload?.userCustomDomain;
        state.domains = payload?.customDomain;
        state.isHasData = Object.keys(payload).length > 0;
        state.isLoading = false;
      }
    },
    setOwner(state, { payload }) {
      state.store = payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(updatePrevPath.fulfilled, (state, { payload }) => {
      state.prevPath = payload as string;
    });
  },
});

const { actions, reducer: appReducer } = appSlice;

export const { setOwner, initialAppState } = actions;

export default appReducer;

export const selectAppState = (state: RootState): AppState =>
  state.app as AppState;
